// Sending labs at THI. Layout in components/hospital/texas-heart/SendingLabs.js.
// Items marked `confirm: true` are standard conventions awaiting the site's confirmation.

// One row per lab. Tube colours follow the usual conventions until the site confirms its own.
export const labs = [
  {
    test: 'Rapid Response Lab (RRL) panel',
    note: "THI's blood gas panel: ABG, H/H, Na, K and glucose. Add on an ionized calcium when you need one.",
    tube: 'Blood gas syringe', color: '#9ca3af', highlight: true,
  },
  { test: 'Ionized calcium', note: 'Usually an add-on to the RRL panel', tube: 'Blood gas syringe', color: '#9ca3af' },
  { test: 'CBC / H&H', tube: 'Purple (EDTA)', color: '#a78bfa' },
  { test: 'BMP / chemistry', tube: 'Green (lithium heparin)', color: '#22c55e', confirm: true },
  { test: 'Lactic acid', note: 'Stat lab', tube: 'Blood gas syringe', color: '#9ca3af' },
  { test: 'Platelet count', tube: 'Purple (EDTA)', color: '#a78bfa' },
  { test: 'Coags (PT/INR, PTT, fibrinogen)', tube: 'Light blue (citrate)', color: '#60a5fa' },
  { test: 'Tryptase', tube: 'Gold (SST)', color: '#eab308' },
  { test: 'Ketones', tube: 'Dark green', color: '#15803d' },
  { test: 'ROTEM', note: 'See below', tube: 'Light blue (citrate)', color: '#60a5fa' },
  { test: 'Type and screen', note: 'Handwritten label, see below', tube: 'Pink (EDTA)', color: '#f472b6' },
  { test: 'ACT', note: 'Run by the perfusionist during CPB', tube: 'Plain syringe', color: '#e5e7eb' },
];

export const sendingSteps = [
  'Place the order in Epic',
  "The label prints at the nurses' desk",
  'The nurse double-checks the label against the chart',
  'The nurse brings the stickers to the anesthesiologist',
  'The anesthesiologist labels the tubes and syringes',
  'The nurse calls a PCA to pick up the labs',
];

export const typeAndScreen = {
  text: 'Type and screen samples use a handwritten label, not the printed sticker.',
  fields: ['Patient name', 'MRN', 'Date of birth', 'Date and time drawn', "Collector's initials"],
  confirm: true,
};

export const rotem = {
  text: 'ROTEM guides transfusion after CPB.',
  pending: 'Where it is run, who runs it and how it is ordered: coming.',
  algorithm: '/thi/thi-rotem-transfusion-protocol.pdf',
};
